import { FeedbackDeleteActionType, Action } from "../Actions/FeedbackDeleteActions";
import { BugReport, FeatureRequest } from "../Models/Feedback";

export interface FeedbackDeleteState {
  contentIsLoaded: boolean;
  isLoading: boolean;
  feedback: FeatureRequest | BugReport | null;
  hasError: boolean;
  errorCode: number | null;
  errorDescription: string;
}

const initialState: FeedbackDeleteState = {
  contentIsLoaded: false,
  isLoading: false,
  feedback: null,
  hasError: false,
  errorCode: null,
  errorDescription: ""
};

const updateObject = (oldObject: any, newValues: any) => ({ ...oldObject, ...newValues });

const feedbackDeleteReducer = (state: FeedbackDeleteState = initialState, action: Action<any>) => {
  switch (action.type) {
    case FeedbackDeleteActionType.SET_FEEDBACK_DETAILS:
      return updateObject(state, {
        feedback: action.payload,
        contentIsLoaded: true,
        isLoading: false
      });
    case FeedbackDeleteActionType.SET_LOADING:
      return updateObject(state, {
        isLoading: true
      });
    case FeedbackDeleteActionType.RESET_LOADING:
      return updateObject(state, {
        isLoading: false,
        hasError: false,
        errorCode: "",
        errorDescription: ""
      });
    case FeedbackDeleteActionType.UPDATE_LOADED_FEEDBACK_DETAILS:
      return updateObject(state, {
        feedback: action.payload
      });
    case FeedbackDeleteActionType.RESET_LOADED:
      return updateObject(state, {
        contentIsLoaded: false
      });
    case FeedbackDeleteActionType.SET_ERROR:
      return updateObject(state, {
        hasError: true,
        errorCode: action.payload.errorCode,
        errorDescription: action.payload.errorDescription
      });
    default:
      return state;
  }
};

export default feedbackDeleteReducer;
